export default __webpack_public_path__ + "static/media/banner2.4a4dc62f.png";